import React from 'react';
import {isMobile as isMobileType} from 'react-device-detect';

export const useMobile = () => {
  const [isMobileSize, setIsMobileSize] = React.useState(
    window.innerWidth <= 640,
  );

  React.useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsMobileSize(window.innerWidth <= 640);
    };
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return isMobileType || isMobileSize;
};
